/**
 * components/legal/vop/vopVersion.ts
 *
 * Which wording of the general terms a person accepts on the consent screen:
 * the date of counsel's draft the published text is built from. The service
 * keeps the same string (`CURRENT_TERMS_VERSION` in
 * `optivo-service/src/services/core/termsConsent.ts`) and asks everybody
 * whose last acceptance names another one to accept again;
 * `consent/termsConsentItems.parity.test.ts` holds the two together.
 *
 * Change it only for a change of the terms a customer has to agree to again.
 * A fix that changes no right or duty (a typo, a renamed screen) keeps it.
 */
export const VOP_VERSION = "2026-10-27";
